import { render, staticRenderFns } from "./DeliveryKeywordMgmt.vue?vue&type=template&id=542bbd92"
import script from "./DeliveryKeywordMgmt.vue?vue&type=script&lang=js"
export * from "./DeliveryKeywordMgmt.vue?vue&type=script&lang=js"
import style0 from "./DeliveryKeywordMgmt.vue?vue&type=style&index=0&id=542bbd92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports